import { testimonials } from '@/mocks/comics';

export default function TestimonialSection() {
  return (
    <section className="py-16 md:py-24 px-6 bg-background-100">
      <div className="max-w-screen-xl mx-auto">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-500/10 border border-accent-500/20 text-accent-400 text-xs font-medium mb-4">
            <i className="ri-star-fill text-xs"></i>
            读者口碑
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-50">
            数百万读者的选择
          </h2>
        </div>

        {/* Testimonials Grid - irregular layout */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {/* Card 1 - text */}
          <div className="bg-background-200 rounded-lg p-6 flex flex-col">
            <div className="flex items-center gap-3 mb-4">
              <img
                src={testimonials[0].avatar}
                alt={testimonials[0].name}
                className="w-10 h-10 rounded-full object-cover"
                loading="lazy"
              />
              <div>
                <p className="text-sm font-semibold text-foreground-100">{testimonials[0].name}</p>
                <p className="text-xs text-foreground-500">{testimonials[0].role}</p>
              </div>
            </div>
            <i className="ri-double-quotes-l text-2xl text-primary-500/30 mb-3"></i>
            <p className="text-sm text-foreground-300 leading-relaxed flex-1">
              {testimonials[0].comment}
            </p>
            <div className="flex items-center gap-1 mt-4">
              {[...Array(testimonials[0].rating)].map((_, i) => (
                <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
              ))}
            </div>
          </div>

          {/* Card 2 - text */}
          <div className="bg-background-200 rounded-lg p-6 flex flex-col">
            <div className="flex items-center gap-3 mb-4">
              <img
                src={testimonials[1].avatar}
                alt={testimonials[1].name}
                className="w-10 h-10 rounded-full object-cover"
                loading="lazy"
              />
              <div>
                <p className="text-sm font-semibold text-foreground-100">{testimonials[1].name}</p>
                <p className="text-xs text-foreground-500">{testimonials[1].role}</p>
              </div>
            </div>
            <i className="ri-double-quotes-l text-2xl text-primary-500/30 mb-3"></i>
            <p className="text-sm text-foreground-300 leading-relaxed flex-1">
              {testimonials[1].comment}
            </p>
            <div className="flex items-center gap-1 mt-4">
              {[...Array(testimonials[1].rating)].map((_, i) => (
                <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
              ))}
            </div>
          </div>

          {/* Card 3 - photo background */}
          <div className="relative rounded-lg overflow-hidden aspect-[4/5] md:aspect-auto">
            <img
              src="https://readdy.ai/api/search-image?query=Korean%20young%20woman%20reading%20manhwa%20on%20phone%2C%20cozy%20cafe%20environment%2C%20warm%20ambient%20lighting%2C%20focused%20expression%2C%20lifestyle%20photography%2C%20cinematic%20mood%2C%20soft%20bokeh%20background&width=600&height=800&seq=testimonial-photo-01&orientation=portrait"
              alt="读者"
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-50/90 via-background-50/20 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-5">
              <p className="text-sm font-semibold text-foreground-50">{testimonials[2].name}</p>
              <p className="text-xs text-foreground-400 mt-0.5">{testimonials[2].role}</p>
            </div>
          </div>

          {/* Card 4 - wide text card */}
          <div className="md:col-span-2 relative rounded-lg overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Korean%20man%20and%20woman%20reading%20comics%20together%20on%20tablet%2C%20modern%20living%20room%2C%20warm%20evening%20lighting%2C%20cozy%20atmosphere%2C%20lifestyle%20photography%2C%20soft%20natural%20light&width=900&height=500&seq=testimonial-photo-02&orientation=landscape"
              alt="读者"
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-background-50/95 via-background-50/70 to-background-50/20" />
            <div className="absolute inset-0 p-6 flex flex-col justify-end">
              <p className="text-sm font-semibold text-foreground-50">{testimonials[3].name}</p>
              <p className="text-xs text-foreground-400 mt-0.5">{testimonials[3].role}</p>
              <p className="text-sm text-foreground-300 leading-relaxed mt-4 max-w-md">
                {testimonials[3].comment}
              </p>
            </div>
          </div>

          {/* Card 5 - small text */}
          <div className="bg-background-200 rounded-lg p-6 flex flex-col">
            <i className="ri-double-quotes-l text-2xl text-primary-500/30 mb-3"></i>
            <p className="text-sm text-foreground-300 leading-relaxed flex-1">
              {testimonials[4].comment}
            </p>
            <div className="flex items-center gap-2 mt-4">
              <img
                src={testimonials[4].avatar}
                alt={testimonials[4].name}
                className="w-8 h-8 rounded-full object-cover"
                loading="lazy"
              />
              <div>
                <p className="text-xs font-semibold text-foreground-100">{testimonials[4].name}</p>
                <p className="text-xs text-foreground-500">{testimonials[4].role}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}